import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Measure from "../../../shared/models/Measure";
import Objective from "../../../shared/models/Objective";
import {
  bodyText,
  header,
  marginTopBottom,
  sectionHeader,
  signatureHeader,
  signatureTable,
} from "../../../shared/functions/scorecard-pdf/DocDefition";
import {
  brandLogo,
  brandLogo1,
  getBase64ImageFromURL,
} from "../../../shared/functions/scorecard-pdf/ImageLoader";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
// const GenereateIndividualFinalPDF = (objectives: Objective[]) => {
//   const documentDefinition: any = {
//     pageOrientation: "landscape", // Set the PDF to landscape mode
//     pageMargins: [10, 10, 10, 10], // Set page-wide margins
//     content: [
//       { text: "Agreement Report", style: "header" },
//       ...objectives.map((objective) => ({
//         stack: [
//           { text: `Objective: ${objective.asJson.description}`, style: "subheader" },
//           { text: `Perspective: ${objective.asJson.perspective}`, italics: true },
//           { text: `Weight: ${objective.asJson.weight}%`, italics: true },
//           {
//             stack: [
//               {
//                 table: {
//                   headerRows: 1,
//                   widths: ["23%", "*", "*", "*", "*", "*", "*", "*", "*", "*", "*", "*", "*"], // Adjusted for additional columns
//                   body: [
//                     [
//                       { text: "KPI", style: "tableHeader" },
//                       { text: "Baseline", style: "tableHeader" },
//                       { text: "Rate 1", style: "tableHeader" },
//                       { text: "Rate 2", style: "tableHeader" },
//                       { text: "Rate 3", style: "tableHeader" },
//                       { text: "Rate 4", style: "tableHeader" },
//                       { text: "Rate 5", style: "tableHeader" },
//                       { text: "Annual Target", style: "tableHeader" },
//                       { text: "Progress Update", style: "tableHeader" },
//                       { text: "Midterm E-Rating", style: "tableHeader" },
//                       { text: "Midterm S-Rating", style: "tableHeader" },
//                       { text: "Final E-Rating", style: "tableHeader" },
//                       { text: "Final S-Rating", style: "tableHeader" },
//                     ],
//                     ...objective.measures.map((measure: Measure) => [
//                       { text: measure.asJson.description, style: "tableCell" },
//                       { text: measure.asJson.baseline, style: "tableCell" },
//                       { text: measure.asJson.rating1, style: "tableCell" },
//                       { text: measure.asJson.rating2, style: "tableCell" },
//                       { text: measure.asJson.rating3, style: "tableCell" },
//                       { text: measure.asJson.rating4, style: "tableCell" },
//                       { text: measure.asJson.rating5, style: "tableCell" },
//                       { text: measure.asJson.annualTarget, style: "tableCell" },
//                       { text: measure.asJson.midtermActual, style: "tableCell" },
//                       { text: measure.asJson.midtermAutoRating, style: "tableCell" },
//                       { text: measure.asJson.midtermRating || "-", style: "tableCell" },
//                       { text: measure.asJson.autoRating || "-", style: "tableCell" }, // Final E-Rating
//                       { text: measure.asJson.finalRating || measure.asJson.autoRating || "-", style: "tableCell" }, // Final S-Rating
//                     ]),
//                   ],
//                 },
//                 layout: "lightHorizontalLines",
//               },
//             ],
//             margin: [10, 10, 50, 10]// Apply margin to the stack wrapping the table
//           },
//         ],
//       })),
//     ],
//     styles: {
//       header: { fontSize: 18, bold: true, margin: [0, 0, 0, 10] },
//       subheader: { fontSize: 14, bold: true, margin: [0, 10, 0, 5] },
//       tableHeader: { bold: true, fillColor: "#eeeeee", fontSize: 10 }, // Smaller font for headers
//       tableCell: { fontSize: 8 }, // Smaller font size for table data
//     },
//   };

//   pdfMake.createPdf(documentDefinition).download("Agreement_Report.pdf");
// };

const GenereateIndividualFinalPDF = async (objectives) => {
  const documentDefinition: any = {
    pageOrientation: "landscape", // Set the PDF to landscape mode
    pageMargins: [10, 10, 10, 10], // Updated page-wide margins

    content: [
      // Logo
      await brandLogo1(),

      // Header
      marginTopBottom(),
      header(
        `Performance Report | ${
          "Phillip P. Domingos"
          // scorecardName
        }`
      ), // Username, Scorecard year
      sectionHeader("Introduction"),
      bodyText(
        `This document highlights the performance of ${
          "Phillip P. Domingos"
          // scorecardName
        }` // Username, Scorecard year
      ),
      sectionHeader("Objectives", ""), // Objectives overall
      bodyText("This section is for evaluating accomplishments of goals."),
      bodyText(
        "The weights for the goals in this section must add up to 100, and there must be a rating for each goal before the form is sent for signatures"
      ),

      // Objectives Table
      ...objectives.map((objective) => ({
        stack: [
          {
            text: `Objective: ${objective.asJson.description}`,
            style: "subheader",
          },
          {
            text: `Perspective: ${objective.asJson.perspective}`,
            italics: true,
          },
          { text: `Weight: ${objective.asJson.weight}%`, italics: true },
          {
            stack: [
              {
                table: {
                  headerRows: 1,
                  widths: [
                    "23%",
                    "*",
                    "*",
                    "*",
                    "*",
                    "*",
                    "*",
                    "*",
                    "*",
                    "*",
                    "*",
                    "*",
                    "*",
                  ],
                  body: [
                    [
                      { text: "KPI", style: "tableHeader" },
                      { text: "Baseline", style: "tableHeader" },
                      { text: "Rate 1", style: "tableHeader" },
                      { text: "Rate 2", style: "tableHeader" },
                      { text: "Rate 3", style: "tableHeader" },
                      { text: "Rate 4", style: "tableHeader" },
                      { text: "Rate 5", style: "tableHeader" },
                      { text: "Annual Target", style: "tableHeader" },
                      { text: "Progress Update", style: "tableHeader" },
                      { text: "Midterm E-Rating", style: "tableHeader" },
                      { text: "Midterm S-Rating", style: "tableHeader" },
                      { text: "Final E-Rating", style: "tableHeader" },
                      { text: "Final S-Rating", style: "tableHeader" },
                    ],
                    ...objective.measures.map((measure) => [
                      { text: measure.asJson.description, style: "tableCell" },
                      { text: measure.asJson.baseline, style: "tableCell" },
                      { text: measure.asJson.rating1, style: "tableCell" },
                      { text: measure.asJson.rating2, style: "tableCell" },
                      { text: measure.asJson.rating3, style: "tableCell" },
                      { text: measure.asJson.rating4, style: "tableCell" },
                      { text: measure.asJson.rating5, style: "tableCell" },
                      { text: measure.asJson.annualTarget, style: "tableCell" },
                      {
                        text: measure.asJson.midtermActual,
                        style: "tableCell",
                      },
                      {
                        text: measure.asJson.midtermAutoRating,
                        style: "tableCell",
                      },
                      {
                        text: measure.asJson.midtermRating || "-",
                        style: "tableCell",
                      },
                      {
                        text: measure.asJson.autoRating || "-",
                        style: "tableCell",
                      },
                      {
                        text:
                          measure.asJson.finalRating ||
                          measure.asJson.autoRating ||
                          "-",
                        style: "tableCell",
                      },
                    ]),
                  ],
                },
                layout: "lightHorizontalLines",
              },
            ],
            margin: [10, 10, 60, 10],
          },
        ],
      })),

      // Signatures
      signatureHeader(),
      signatureTable(""),
    ],

    styles: {
      header: { fontSize: 18, bold: true, margin: [0, 0, 0, 10] },
      subheader: { fontSize: 14, bold: true, margin: [0, 10, 0, 5] },
      tableHeader: { bold: true, fillColor: "#eeeeee", fontSize: 10 },
      tableCell: { fontSize: 8 },
      brandLogo: { alignment: "right" },
      sectionHeader: { fontSize: 12, margin: [0, 15, 0, 5], bold: true },
      signature: { margin: [0, 30, 0, 5] },
      signatureTable: { margin: [0, 5, 0, 5] },
    },
  };

  pdfMake.createPdf(documentDefinition).download("Performance_Report.pdf");
};

export default GenereateIndividualFinalPDF;
